module.exports = __webpack_public_path__ + "static/img/photo6.31e71223.jpg";